<wiz-hgroup width="100%" height="100%">
  <ng-container *ngTemplateOutlet="currentTemplate"></ng-container>
</wiz-hgroup>

<ng-template #noTemplate>
  <wiz-hgroup height="100%" width="100%" horizontalAlign="center" verticalAlign="center">
    <wiz-label [wizLabel]="'$.chart.error.message.template.$'"></wiz-label>
  </wiz-hgroup>
</ng-template>

<ng-template #pieTemplate>
  <ngx-charts-pie-chart
    [animations]="animations"
    [legend]="legend"
    [legendTitle]="legendTitle"
    [legendPosition]="legendPosition"
    [scheme]="scheme"
    [tooltipDisabled]="!tooltipDisabled"
    [labels]="labels"
    [results]="dataset"
  >
  </ngx-charts-pie-chart>
</ng-template>

<ng-template #barTemplate>
  <ngx-charts-bar-vertical
    [animations]="animations"
    [legend]="legend"
    [legendTitle]="legendTitle"
    [legendPosition]="legendPosition"
    [scheme]="scheme"
    [tooltipDisabled]="!tooltipDisabled"
    [xAxis]="xAxis"
    [yAxis]="yAxis"
    [showXAxisLabel]="showXAxisLabel"
    [xAxisLabel]="xAxisLabel"
    [showYAxisLabel]="showYAxisLabel"
    [yAxisLabel]="yAxisLabel"
    [showDataLabel]="showDataLabel"
    [yScaleMax]="yScaleMax"
    [yScaleMin]="yScaleMin"
    [results]="dataset"
    [trimXAxisTicks]="trimXAxisTicks"
    [trimYAxisTicks]="trimYAxisTicks"
    [maxXAxisTickLength]="maxXAxisTickLength"
    [maxYAxisTickLength]="maxYAxisTickLength"
    [barPadding]="barPadding"
  >
  </ngx-charts-bar-vertical>
</ng-template>

<ng-template #hBarTemplate>
  <ngx-charts-bar-horizontal
    [animations]="animations"
    [legend]="legend"
    [legendTitle]="legendTitle"
    [legendPosition]="legendPosition"
    [scheme]="scheme"
    [tooltipDisabled]="!tooltipDisabled"
    [xAxis]="xAxis"
    [yAxis]="yAxis"
    [showXAxisLabel]="showXAxisLabel"
    [xAxisLabel]="xAxisLabel"
    [showYAxisLabel]="showYAxisLabel"
    [yAxisLabel]="yAxisLabel"
    [showDataLabel]="showDataLabel"
    [xScaleMax]="xScaleMax"
    [xScaleMin]="xScaleMin"
    [results]="dataset"
    [trimXAxisTicks]="trimXAxisTicks"
    [trimYAxisTicks]="trimYAxisTicks"
    [maxXAxisTickLength]="maxXAxisTickLength"
    [maxYAxisTickLength]="maxYAxisTickLength"
    [barPadding]="barPadding"
  >
  </ngx-charts-bar-horizontal>
</ng-template>

<ng-template #lineTemplate>
  <ngx-charts-line-chart
    [animations]="animations"
    [legend]="legend"
    [legendTitle]="legendTitle"
    [legendPosition]="legendPosition"
    [scheme]="scheme"
    [tooltipDisabled]="!tooltipDisabled"
    [xAxis]="xAxis"
    [yAxis]="yAxis"
    [showXAxisLabel]="showXAxisLabel"
    [xAxisLabel]="xAxisLabel"
    [showYAxisLabel]="showYAxisLabel"
    [yAxisLabel]="yAxisLabel"
    [xScaleMax]="xScaleMax"
    [xScaleMin]="xScaleMin"
    [yScaleMax]="yScaleMax"
    [yScaleMin]="yScaleMin"
    [results]="dataset"
    [trimXAxisTicks]="trimXAxisTicks"
    [trimYAxisTicks]="trimYAxisTicks"
    [maxXAxisTickLength]="maxXAxisTickLength"
    [maxYAxisTickLength]="maxYAxisTickLength"
  >
  </ngx-charts-line-chart>
</ng-template>

<ng-template #gaugeTemplate>
  <ngx-charts-gauge
    [animations]="animations"
    [legend]="legend"
    [legendTitle]="legendTitle"
    [legendPosition]="legendPosition"
    [scheme]="scheme"
    [tooltipDisabled]="!tooltipDisabled"
    [min]="min"
    [max]="max"
    [units]="units"
    [bigSegments]="bigSegments"
    [showAxis]="showAxis"
    [angleSpan]="angleSpan"
    [showText]="showText"
    [results]="dataset"
  >
  </ngx-charts-gauge>
</ng-template>

<ng-template #cardTemplate>
  <ngx-charts-number-card 
  [animations]="animations" 
  [scheme]="scheme"
  [bandColor]="color"
  [results]="dataset"> </ngx-charts-number-card>
</ng-template>

<ng-template #treemapTemplate>
  <ngx-charts-tree-map
    [animations]="animations"
    [scheme]="scheme"
    [tooltipDisabled]="!tooltipDisabled"
    [results]="dataset"
  >
  </ngx-charts-tree-map>
</ng-template>

<ng-template #vbarstackedTemplate>
  <ngx-charts-bar-vertical-stacked
    [animations]="animations"
    [legend]="legend"
    [legendTitle]="legendTitle"
    [legendPosition]="legendPosition"
    [scheme]="scheme"
    [tooltipDisabled]="!tooltipDisabled"
    [xAxis]="xAxis"
    [yAxis]="yAxis"
    [showXAxisLabel]="showXAxisLabel"
    [xAxisLabel]="xAxisLabel"
    [showYAxisLabel]="showYAxisLabel"
    [yAxisLabel]="yAxisLabel"
    [showDataLabel]="showDataLabel"
    [yScaleMax]="yScaleMax"
    [results]="dataset"
    [trimXAxisTicks]="trimXAxisTicks"
    [trimYAxisTicks]="trimYAxisTicks"
    [maxXAxisTickLength]="maxXAxisTickLength"
    [maxYAxisTickLength]="maxYAxisTickLength"
    [barPadding]="barPadding"
  >
  </ngx-charts-bar-vertical-stacked>
</ng-template>

<ng-template #vbargroupedTemplate>
  <ngx-charts-bar-vertical-2d
    [animations]="animations"
    [legend]="legend"
    [legendTitle]="legendTitle"
    [legendPosition]="legendPosition"
    [scheme]="scheme"
    [tooltipDisabled]="!tooltipDisabled"
    [xAxis]="xAxis"
    [yAxis]="yAxis"
    [showXAxisLabel]="showXAxisLabel"
    [xAxisLabel]="xAxisLabel"
    [showYAxisLabel]="showYAxisLabel"
    [yAxisLabel]="yAxisLabel"
    [showDataLabel]="showDataLabel"
    [yScaleMax]="yScaleMax"
    [results]="dataset"
    [trimXAxisTicks]="trimXAxisTicks"
    [trimYAxisTicks]="trimYAxisTicks"
    [maxXAxisTickLength]="maxXAxisTickLength"
    [maxYAxisTickLength]="maxYAxisTickLength"
    [barPadding]="barPadding"
  >
  </ngx-charts-bar-vertical-2d>
</ng-template>

<ng-template #hbarstackedTemplate>
  <ngx-charts-bar-horizontal-stacked
    [animations]="animations"
    [legend]="legend"
    [legendTitle]="legendTitle"
    [legendPosition]="legendPosition"
    [scheme]="scheme"
    [tooltipDisabled]="!tooltipDisabled"
    [xAxis]="xAxis"
    [yAxis]="yAxis"
    [showXAxisLabel]="showXAxisLabel"
    [xAxisLabel]="xAxisLabel"
    [showYAxisLabel]="showYAxisLabel"
    [yAxisLabel]="yAxisLabel"
    [showDataLabel]="showDataLabel"
    [xScaleMax]="xScaleMax"
    [results]="dataset"
    [trimXAxisTicks]="trimXAxisTicks"
    [trimYAxisTicks]="trimYAxisTicks"
    [maxXAxisTickLength]="maxXAxisTickLength"
    [maxYAxisTickLength]="maxYAxisTickLength"
    [barPadding]="barPadding"
  >
  </ngx-charts-bar-horizontal-stacked>
</ng-template>

<ng-template #polarTemplate>
  <ngx-charts-polar-chart
    [legend]="legend"
    [legendTitle]="legendTitle"
    [legendPosition]="legendPosition"
    [scheme]="scheme"
    [results]="dataset"
    [showXAxisLabel]="showXAxisLabel"
    [showYAxisLabel]="showYAxisLabel"
    [xAxis]="xAxis"
    [yAxis]="yAxis"
    [animations]="false"
    [labelTrim]="false"
  >
  </ngx-charts-polar-chart>
</ng-template>
